<template>
	<div>
		<div class="scalarWrapper box">
			<div class="scalarList clearfix" @click="toinfo(li)" v-for="li in scalarList">
				<div class="listfl fl">
					<p class="title">{{li.name}}</p>
					<p class="desc">{{li.introduction}}</p>
					<p class="clearfix readNum">
						<span class="fl">适宜年龄:{{li.suitable_age}}</span>
						<span class="fr" v-if="li.id==69" style="text-decoration: line-through;">测试价格：￥50.00</span>
            <span class="fr" v-if="li.id==4" style="text-decoration: line-through;">测试价格：￥50.00</span>
            <span class="fr" v-if="li.id==80" style="text-decoration: line-through;">测试价格：￥280.00</span>
            <span class="fr" v-if="li.id==92" style="text-decoration: line-through;">测试价格：￥40.00</span>
						<!--<span class="fr icon">&#xe886;</span>-->
					</p>
				</div>
				<div class="fr imgBox">
					<img v-bind:src="photo+li.picture.data[0].list" alt="" style="height: 100%;width: 100%;"/>
				</div>
			</div>
		</div>
		<bottomBar :bottom="bottom"></bottomBar>
	</div>
</template>

<script>
	import bottomBar from '../components/bottomBar.vue'
	export default {
		data() {
			return {
				bottom: 1,
				insituation:null,
				scalarList:[],
				photo:photoUrl
			}
		},
		created: function() {
			document.title = '测评列表';
			this.insituation = searchParam('insituation');
			if(this.insituation!=null){
				sessionStorage.setItem('insituation',this.insituation);
			}else{
				this.insituation = sessionStorage.getItem('insituation');
			}
			this.getScalar();
			var openid = searchParam('openid');
			if(openid!=null){
				this.share(openid);
			}else{
				if(localStorage.getItem('user')){
					this.share(JSON.parse(localStorage.getItem('user')).openid);
				}
			}
			this.loadUser();
		},
		methods: {
			toinfo:function(li){
				sessionStorage.setItem('id',li.id);
				this.$router.push({name:'scalarinfo',params:{id:li.id}});
			},
			getScalar:function(){
				var that = this;
				http.get('institutions/'+this.insituation+'/scalars').then(function(res){
					if(res.data.data.length==0){
						that.$router.push({name:'delay'});
					}else{
						that.scalarList = res.data.data;
					}

				})
			},
			share:function(openid){
				var that = this;
				var url = 'institutions/'+this.insituation+'/users/'+openid;
				http.get(url).then(function(res){
					localStorage.setItem('user',JSON.stringify(res.data.data));
					loadShare(res.data.data.name+'的家庭调研', '了解家庭中的人格与养育，增加包容与支持的生活智慧', '11',location.href.split('#')[0]+'#/scalarlist?insituation='+that.insituation+'&openid='+openid);
				}).catch(function(res){
					console.log(res)
				})
			},
			loadUser:function(){
				if(localStorage.getItem('user')){
					var openid = JSON.parse(localStorage.getItem('user')).openid;
					var that = this;
					var url = 'institutions/'+this.insituation+'/users/'+openid;
					http.get(url).then(function(res){
//						localStorage.setItem('user',JSON.stringify(res.data.data));
//						loadShare(res.data.data.name+'的家庭调研', '了解家庭中的人格与养育，增加包容与支持的生活智慧', '11',location.href.split('#')[0]+'#/scalarlist?insituation='+that.insituation+'&openid='+openid);
					}).catch(function(res){
						localStorage.removeItem('user');
					})
				}
			}
		},
		components: {
			bottomBar
		},
	}
</script>

<style scoped>
	.scalarWrapper {
		width: 100%;
		padding: 0 0.2rem;
		padding-bottom: 1.5rem;
		/*padding-top: 0.5rem;*/
	}
	.scalarList{
		border-bottom:1px solid #CCCCCC;
		padding: 0.2rem 0;
	}
	.listfl{
		width: 5.3rem;
	}
	.title {
		line-height: 0.42rem;
		font-size: 0.30rem;
		color: #434343;
		font-weight: 700;
		margin-bottom: 0.12rem;
	}

	.desc {
		line-height: 0.28rem;
		font-size: 0.24rem;
		color: rgba(67, 67, 67, 0.6);
		margin-bottom: 0.20rem;
		height: 0.56rem;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}
	.imgBox{
		height: 1.6rem;
		width: 1.6rem;
	}
	.readNum span{
		line-height:0.28rem;
		color:#666;
		font-size:0.20rem;
	}
	.readNum .icon{
		margin-right:0.08rem;
		color:#F47B7B;
	}
</style>



// WEBPACK FOOTER //
// src/pages/scalarlist.vue